import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'polylearn-lerobert-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss', '../styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LerobertHomeComponent implements OnInit {
  items = [
    {
      title: 'Évaluez-vous',
      text: 'Mesurez votre score initial et définissez votre objectif'
    },
    {
      title: 'Entraînez-vous',
      text: 'Progressez rapidement grâce à 16 modules complets'
    },
    {
      title: 'Optimisez votre score',
      text: ' Notre technologie ciblera vos difficultés pour les éliminer'
    },
    {
      title: 'Réussissez',
      text:
        'Atteignez votre objectif en vous mettant en situation d’examen grâce aux tests blancs'
    }
  ];

  items2 = [
    {
      title: 'Mesurer son niveau<br>et progresser',
      items: [
        'Plateforme de formation en ligne : 4 mois',
        'Accompagnement par un formateur dédié : 2&nbsp;h&nbsp;30'
      ],
      img: 'logo-formation-le-robert'
    },
    {
      title: 'S’évaluer<br>et se certifier',
      items: [
        '1<sup>re</sup> certification globale en langue française',
        'Test certifiant réalisé en centre La Poste ou à distance'
      ],
      img: 'logo-certification-le-robert'
    },
    {
      title: 'Consolider ses acquis<br>et se perfectionner',
      items: [
        'Logiciel PC/Mac de référence',
        'Aide à la rédaction et perfectionnement en français'
      ],
      img: 'logo-horizontal-le-robert-correcteur'
    }
  ];

  items3 = [
    {
      title: 'Sciences cognitives',
      text:
        'Nous définissons à partir de vos réponses et de votre profil pédagogique une session d’entraînement adaptée.'
    },
    {
      title: 'Apprentissage algorithmique',
      text:
        'Notre plateforme tire parti de l’ensemble des parcours de formation de nos apprenants afin de vous offrir l’expérience la plus efficace possible.'
    },
    {
      title: 'Efficacité',
      text:
        'Nous mettons à votre disposition tout notre savoir-faire pour que vous progressiez en un temps record !'
    }
  ];

  items4 = [
    {
      title: 'Offre CPF complète',
      text: 'Salariés, demandeurs d’emploi, alternants',
      button: {
        text: 'Plus d’informations',
        routerLink: 'cpf-mon-compte-compte-formation'
      },
      items: [
        {
          title: 'Plateforme de formation',
          items: [
            'Tableau de bord',
            'Suivi de la progression',
            'Test de positionnement',
            'Différents modes d’entraînement',
            'Plus de 5 000 questions-réponses',
            'Corrigés détaillés',
            'Toutes les règles dans tous les domaines',
            'Tests blancs'
          ]
        },
        { title: 'Accompagnement individuel 2 h 30' },
        { title: 'Certification Le Robert' },
        { title: 'Le Robert Correcteur PC/Mac inclus' }
      ]
    },
    {
      title: 'Offre sur mesure',
      text: 'Écoles, organismes de formation, entreprises',
      button: {
        text: 'Nous contacter',
        link: 'https://pro.lerobert.com/contact.html'
      },
      items: [
        {
          title: 'Tous les contenus et les fonctionnalités CPF disponibles',
          items: [
            'Gestion de groupes d’apprenants',
            'Suivi de la progression par groupe et par apprenant',
            'Planification de tests blancs',
            'Correction automatique des tests blancs'
          ]
        },
        {
          title: 'Espace administrateur'
        }
      ]
    }
  ];

  constructor() {}

  ngOnInit(): void {}
}
